import { gql } from '@/__generated__';

export const productVariantDocument = gql(/* GraphQL */ `
  query ProductVariant($where: ProductVariantWhereUniqueInput!) {
    productVariant(where: $where) {
      id
      lines {
        id
        price
        createdAt
        order {
          id
          package
          total
          customer {
            id
            name
          }
        }
      }
    }
  }
`);
